export { default, type AppBreadcrumbs } from '../Breadcrumbs/Breadcrumbs';
